/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function TutorialAnchorInstructionsFromJSON(json) {
    return TutorialAnchorInstructionsFromJSONTyped(json, false);
}
export function TutorialAnchorInstructionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'textId': !exists(json, 'text_id') ? undefined : json['text_id'],
        'overlayImage': !exists(json, 'overlay_image') ? undefined : json['overlay_image'],
    };
}
export function TutorialAnchorInstructionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'text_id': value.textId,
        'overlay_image': value.overlayImage,
    };
}
//# sourceMappingURL=TutorialAnchorInstructions.js.map